(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beautygala-color-picker"] && !Shopify.designMode) return;
  try {
    class BeautygalaColorPicker extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('[data-cart-form]');
      this.search = this.querySelector('[data-color-search]');
      this.grid = this.querySelector('.beautygala-colors__grid');
      this.rows = Array.from(this.querySelectorAll('[data-row]'));
      this.empty = this.querySelector('[data-color-empty]');
      this.addBtn = this.querySelector('[data-add]');
      this.total = this.querySelector('[data-total]');
      this.picked = new Map();

      const lazy = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ isIntersecting, target }) => {
            if (!isIntersecting) return;
            target.src = target.dataset.src;
            lazy.unobserve(target);
          });
        },
        { root: this.grid, rootMargin: '200px 0px' }
      );
      this.querySelectorAll('img[data-src]').forEach((img) => lazy.observe(img));

      let timer;
      this.search.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.filter(), 100);
      });
      this.search.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') event.preventDefault();
      });

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-step]');
        if (!step) return;
        const input = step.parentElement.querySelector('[data-qty]');
        this.set(input, (parseInt(input.value, 10) || 0) + Number(step.dataset.step));
      });

      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-qty]')) this.set(event.target, parseInt(event.target.value, 10) || 0);
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.collect(event), true);
        this.form.addEventListener('beautygala:cart', (event) => this.settle(event.detail));
      }
    }

    normalise(text) {
      return text.toLowerCase().replace(/,/g, '.').replace(/\s+/g, ' ').trim();
    }

    // Codes match from the start of a word. A typed dot is taken literally, so
    // "1.0" finds 1.0 but not 10.00; without one, dots are ignored, so "40"
    // still finds 4.0 — and "4,0" counts as "4.0".
    matches(code, term) {
      if (code.startsWith(term)) return true;
      const dotted = term.includes('.');
      const plain = term.replace(/\./g, '');
      return code.split(' ').some((word) => (dotted ? word.startsWith(term) : word.replace(/\./g, '').startsWith(plain)));
    }

    set(input, qty) {
      const max = input.max ? Number(input.max) : Infinity;
      const value = Math.min(Math.max(0, qty), max);
      input.value = value;
      input.closest('[data-row]').classList.toggle('is-selected', value > 0);
      if (value > 0) this.picked.set(input, value);
      else this.picked.delete(input);
      this.update();
    }

    update() {
      let items = 0;
      this.picked.forEach((qty) => (items += qty));
      this.addBtn.disabled = items === 0;
      this.total.hidden = items === 0;
      this.total.textContent = ` (${items})`;
      this.classList.toggle('has-selection', items > 0);
    }

    filter() {
      const term = this.normalise(this.search.value);
      let shown = 0;
      this.rows.forEach((row) => {
        const match = !term || this.matches(row.dataset.code, term);
        row.hidden = !match;
        if (match) shown += 1;
      });
      this.empty.hidden = shown > 0;
      this.grid.scrollTop = 0;
    }

    collect(event) {
      this.form.querySelectorAll('.js-cart-line').forEach((el) => el.remove());
      this.querySelectorAll('[data-row-error]').forEach((el) => el.remove());

      let n = 0;
      this.picked.forEach((qty, input) => {
        const id = document.createElement('input');
        id.type = 'hidden';
        id.name = `items[${n}][id]`;
        id.value = input.dataset.variantId;
        id.className = 'js-cart-line';
        const q = document.createElement('input');
        q.type = 'hidden';
        q.name = `items[${n}][quantity]`;
        q.value = String(qty);
        q.className = 'js-cart-line';
        this.form.append(id, q);
        n += 1;
      });

      if (n === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    settle({ ok, result }) {
      if (ok) {
        Array.from(this.picked.keys()).forEach((input) => this.set(input, 0));
        return;
      }

      // ponytail: a 422 names the shade only inside its text, so the longest
      // picked code found in the message wins; a per-line error API would replace this
      const message = result && (result.description || result.message);
      if (!message) return;
      const hit = Array.from(this.picked.keys())
        .map((input) => {
          const row = input.closest('[data-row]');
          return { row, code: row.querySelector('.beautygala-colors__code').firstChild.textContent.trim() };
        })
        .filter(({ code }) => message.includes(code))
        .sort((a, b) => b.code.length - a.code.length)[0];
      if (!hit) return;
      const { row } = hit;

      const note = document.createElement('p');
      note.className = 'beautygala-colors__row-error';
      note.dataset.rowError = '';
      note.setAttribute('role', 'alert');
      note.textContent = message;
      row.append(note);
      row.scrollIntoView({ block: 'center' });
    }
  }

  customElements.define('beautygala-color-picker', BeautygalaColorPicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["beautygala-facets"] && !Shopify.designMode) return;
  try {
    // Delegated once on document: filter forms that arrive later (section
  // re-render, editor) work without re-binding, and there is one click
  // listener however many forms are on the page.
  document.querySelectorAll('[data-facets-form] .beautygala-facets__apply').forEach((btn) => {
    btn.hidden = true;
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (form && event.target.type !== 'number') form.submit();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.target.type !== 'number') return;
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    event.preventDefault();
    form.submit();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.beautygala-facets__group[open]').forEach((group) => {
      if (!group.contains(event.target)) group.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
